import {lazy} from "react";

export const VoyagesAuditLazy = lazy(() => import('./VoyagesAudit'))